import React from "react"
import PropTypes from "prop-types"

class UserPreview extends React.Component {
  constructor(props) {
    super(props)


    this.state = {
      imageRemoved: false,
      accountCancelled: false
    }

    this.nativeLanguages = this.nativeLanguages.bind(this)
    this.learningLanguages = this.learningLanguages.bind(this)
    this.removeImage = this.removeImage.bind(this)
    this.cancelAccount = this.cancelAccount.bind(this)
  }

  nativeLanguages() {
    return this.props.user.languages_users.map((lu, i) => {
      if(lu.level === 5) {
        return lu.language.language
      }
    })
  }

  learningLanguages() {
    return this.props.user.languages_users.map((lu, i) => {
      if(lu.level != 5) {
        return `${lu.language.language},  `
      }
    })
  }

  removeImage() {
    $.ajax({
      url: `../remove_avatar/${this.props.user.id}`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {
        this.setState({
          imageRemoved: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });


  }

  cancelAccount() {

    $.ajax({
      url: `../cancel_user/${this.props.user.id}`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {
        this.setState({
          accountCancelled: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  render() {

    return(
      <div className="admin_user_preview table_row" style={{display: 'flex', justifyContent: 'space-around'}}>
        <button onClick={() => window.open(`/profile/${this.props.user.slug}`)}>
        <img
          src={(this.props.user.avatar_url === "medium/missing.png") ? this.props.missingImg : this.props.user.avatar_url}
          style={{
            borderRadius: 10,
            height: 100,
            width: 100,
            cursor: 'pointer'
          }}
        />
        </button>
        <div style={{width: '65%'}}>
          <p>{this.props.user.first_name} • {this.props.user.nationality}</p>
          <p>Location: {this.props.user.location}</p>
          <p>I speak... {this.nativeLanguages()}</p>
          <p>I am learning... {this.learningLanguages()}</p>
          <p>{this.props.user.bio}</p>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly'}}>
          {this.state.imageRemoved === true ? <p style={{textAlign: 'center'}} className="darkBlue">Image Removed</p>: <button className={"small_button_secondary"} onClick={() => this.removeImage()}>Remove Image</button>}
          {this.state.accountCancelled === true ? <p style={{textAlign: 'center'}} className="darkBlue">Account Cancelled</p>:<button className={"small_button_primary"} onClick={() => this.cancelAccount()}>Cancel Account</button>}
        </div>

      </div>
    )
  }
}

export default UserPreview;
